import styled from 'styled-components';
import {
  TreeView as MuiTreeView,
  TreeItem as MuiTreeItem
} from '@material-ui/lab';

export const TreeView = styled(MuiTreeView)`
  flex-grow: 1;
`;

export const TreeItem = styled(MuiTreeItem)`
  &.selected > [class*='MuiTreeItem-content']:first-child {
    background-color: #cfd8dc;
  }

  & [class*='MuiTreeItem-iconContainer'] {
    width: auto;
    margin: 5px 8px;
    color: rgb(0, 0, 0, 0.54);
  }

  .tree-thin & [class*='MuiTreeItem-group'] {
    margin-left: 12px;
  }

  & [class*='MuiTreeItem-label'] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: inherit;
    color: rgb(0, 0, 0, 0.87);
  }
`;
